import React from "react";

export default function AuditPageShell({
  typeLabel,
  title,
  description,
  children,
}) {
  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <main className="mx-auto max-w-4xl space-y-6">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div className="border-b border-[#E2E8F0] px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
              GMG HO / {typeLabel}
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-[#0F172A] sm:text-3xl">
              {title}
            </h1>
            <p className="mt-2 text-sm text-[#64748B]">{description}</p>
          </div>
        </section>

        <section className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6">
          {children}
        </section>
      </main>
    </div>
  );
}

export function AuditInvalidLinkMessage() {
  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl rounded-2xl border border-[#FECACA] bg-[#FEF2F2] p-5 text-sm text-[#DC2626]">
        Invalid audit link. Use a supported audit URL.
      </div>
    </div>
  );
}
